/**
 * Handles s shader data type.
 */
export enum HsShaderDataType {
  int = 'int',
  float = 'float',
  vec2 = 'vec2',
  vec3 = 'vec3',
  vec4 = 'vec4',
  mat2 = 'mat2',
  mat3 = 'mat3',
  mat4 = 'mat4',
}
